import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { Customer } from "shopping/cart";

@Injectable()
export class CustomerService {
  httpHeaders = new HttpHeaders({ "Content-Type": "application/json" });
  customersUrl = "api/v2/catalogs/";

  constructor(private httpClient: HttpClient) {}

  handleError(error: any): Promise<any> {
    console.error("An error occurred", error);
    return Promise.reject(error.message || error);
  }
}
